import { render, staticRenderFns } from "./huiwan.vue?vue&type=template&id=fc0402c2&scoped=true"
import script from "./huiwan.vue?vue&type=script&lang=js"
export * from "./huiwan.vue?vue&type=script&lang=js"
import style0 from "./huiwan.vue?vue&type=style&index=0&id=fc0402c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0402c2",
  null
  
)

export default component.exports